import { MultiselectCategoryListComponent } from '../../login/createaccountcomponent/categorylist/multiselectcategorylistcomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentHandler, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { PreferenceCategoryListViewImpl } from './preferencecategorylistview';
import { PreferenceCategoryListCSSStyleImpl } from './preferncecategorylistcss';

export class PreferenceCategoryListComponent extends MultiselectCategoryListComponent
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PreferenceCategoryListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new PreferenceCategoryListCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/preferences/preferncecategorylistcomponent.tsx